module.exports = __webpack_public_path__ + "media/application/images/svgs/eye-19014df11635155dfeac5a37aac329da.svg";